import React, { useState, useEffect } from "react";
import { View, StyleSheet, Button, Text, Dimensions, ScrollView } from "react-native";
import { Picker } from "@react-native-picker/picker";
import * as DocumentPicker from "expo-document-picker";
import { Formik } from "formik";
import { formatFecha, handleFileUpload } from "../../Utils/uploadFileS3";
import { SuccessMessage, ErrorMessage } from "./ErrorMessage";
import AsyncStorage from '@react-native-async-storage/async-storage';
const { height } = Dimensions.get('window'); 
import { useNavigate } from 'react-router-dom';


const Form = ({user}) => {
  // console.log('user', user)
  const [fileUploaded, setFileUploaded] = useState(false);
  const [fileValidate, setFileValidate] = useState(false);
  const [fileSelected, setFileSelected] = useState(false);
  const [showErrors, setShowErrors] = useState(false);
  const [errors, setErrors] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [typeSelected, setTypeSelected] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [validationMessage, setValidationMessage] = useState("");
  const [chargeMessage, setChargeMessage] = useState("");
  const [fetchResponse, setFetchResponse] = useState(null);
  const [loadingValidate, setLoadingValidate] = useState(false)
  const [loadingPreCharge, setLoadingPreCharge] = useState(false)
  const [loadingCharge, setLoadingCharge] = useState(false)
  const navigate = useNavigate();

  const handleSelectFile = async () => {
    try {
      const file = await DocumentPicker.getDocumentAsync({
        type: "*/*", //'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // Puedes ajustar el tipo de archivo aquí si es necesario
      });

      if (!file.canceled && file.assets.length > 0) {
        const selectedAsset = file.assets[0];
        const { name, uri } = selectedAsset;
        console.log(name);
        if (!name.endsWith(".xlsx")) {
          setErrorMessage("Por favor, selecciona un archivo .xlsx.");
          setTimeout(() => {
            setErrorMessage("");
          }, 2000);
          console.log("formato invalido");
          return;
        }
        setSelectedFile({ uri, name });
        setFileUploaded(false); // Reiniciar el estado de subida de archivo
        setErrorMessage("");
        setSuccessMessage(""); // Limpiar mensajes previos
        setValidationMessage("");
      }
    } catch (error) {
      console.error("Error al seleccionar el archivo:", error);
    }
  };

  const handleUploadFile = async (values) => {
    if (!selectedFile) {
      setErrorMessage("Por favor, selecciona un archivo primero.");
      return;
    }

    try {
      console.log("Dropdown seleccionado:", values.dropdown);
      let type_selected = values.dropdown;
      setTypeSelected(type_selected)
      setFileSelected(true)
      console.log(selectedFile)
      let fecha = new Date()
      let formattedDate = formatFecha(fecha)
      await handleFileUpload(selectedFile, token, 'https://panel.apis.rotomlabsapis.com/onepanel/generateUploadURLImportador',`panel/importadores/${type_selected}/${formattedDate}`, selectedFile.name)//`resources-one/one_dots/panel/importadores/${type_selected}/${formattedDate}`
      setFileUploaded(true); // Marcar como archivo subido correctamente
      setSuccessMessage("Archivo subido.");
      setTimeout(() => {
        setSuccessMessage("");
      }, 2000);


      // Aquí podrías agregar más lógica después de subir el archivo si es necesario
    } catch (error) {
      console.error("Error al subir el archivo a S3:", error);
      setErrorMessage("Hubo un problema al subir el archivo.");
    }
  };

  const handleValidation = async () => {
    try {
      // Aquí realiza la llamada al servicio usando fetch
      // console.log('viene')
      setLoadingValidate(!loadingValidate)
      const response = await fetch("https://panel.apis.rotomlabsapis.com/onepanel/validate_importer", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization:token//"eyJraWQiOiJBUjM5U3NcL3BcL2NvTjB0eWJ2TlNzSGtnR25PdkRwTEg3d2dFZEpDRTZic2M9IiwiYWxnIjoiUlMyNTYifQ.eyJzdWIiOiIxMTliMzUyMC1iMGMxLTcwMzMtYTEwMS1iODM1MjEzODBlNjMiLCJkZXZpY2Vfa2V5IjoidXMtZWFzdC0yXzZlM2U2MDk2LTYxNWEtNDEzYS1iYzhjLTIwMjc3NDkxYmYzYiIsImNvZ25pdG86Z3JvdXBzIjpbIm9uZV9kb3RzIl0sImlzcyI6Imh0dHBzOlwvXC9jb2duaXRvLWlkcC51cy1lYXN0LTIuYW1hem9uYXdzLmNvbVwvdXMtZWFzdC0yX3JDTmhEUXNHbSIsImNsaWVudF9pZCI6IjU3OW04aWRtZTg5dWxmczcyOXVnOHA1NXV0Iiwib3JpZ2luX2p0aSI6ImY5ZjgzYjkwLWVjNGYtNGUxNi1iYjlkLWNiNmRkZWQ0YzJkMSIsImV2ZW50X2lkIjoiYTAxNWIyMWEtZDMwOS00MWQzLWE5M2QtZTNjOGQ1OWRhODc0IiwidG9rZW5fdXNlIjoiYWNjZXNzIiwic2NvcGUiOiJhd3MuY29nbml0by5zaWduaW4udXNlci5hZG1pbiIsImF1dGhfdGltZSI6MTcyNzg4ODAxMSwiZXhwIjoxNzI3ODkxNjExLCJpYXQiOjE3Mjc4ODgwMTEsImp0aSI6ImI4ODVjOTI2LTdkYjItNDIxYi1iYzRkLWIwMjBkYzg5MTExNSIsInVzZXJuYW1lIjoiZG90c190ZXN0X2ltcG9ydGFkb3JAZG90cy5jb20ifQ.wSjqV3Pu_hCmjlokTahq3F1_0jozpNMuDzd6bmKZ6oLMW8CfE6-PjDllCo7AQLoX16d_D-pPLWcXJKW5IsaaN1Mxnr_unurxfaWfOnGRG0f88-MRITVs2ipDiX9RxhAZ20-emsWm1YBDAzYFGIoBdC08r8WuAktXBM5DZU3PnZXVi0PluCnJ6UvZve9LGjdhxYX_h1OoKXW-t-cK9TRrbzpOXc_kFsBUvkbzhuJgEgSml3dtLYRGYx8yhvMVHRek037DM15Ohxg13xEgDwGAlOhto0-HqdjNkyeuH2S14CoV2ViEMfk-Wwf_0qw7AcQCIgWrBpF54Ks2pqEIJ4JNtA"
        },
        body: JSON.stringify({
          type: typeSelected,
          file_name: selectedFile.name,
          // name_group: 'one_dots'
        }),
      });

      if (response.ok) {
        const data = await response.json();
        // console.log(data.errors,'data')
        if(data.status == 1){

          setValidationMessage("Validación exitosa.");
          setFileValidate(true)
          setLoadingValidate(false)
        }else{
          setValidationMessage("Error en la validación.");
          setShowErrors(true)
          setErrors(data.errors)
          setLoadingValidate(false)
        }
        // Maneja la respuesta de validación según sea necesario
      } else {
        setValidationMessage("Error en la respuesta del servicio.");
      }

      // Limpia el mensaje después de un tiempo
      setTimeout(() => {
        setValidationMessage("");
      }, 2000);
    } catch (error) {
      console.error("Error en la validación:", error);
      setValidationMessage("Hubo un problema en la validación.");
      setTimeout(() => {
        setValidationMessage("");
      }, 2000);
    }
  };

  const handlePreCharge = async () => {
    try {
      setLoadingPreCharge(!loadingPreCharge)

      // Aquí realiza la llamada al servicio usando fetch
      const response = await fetch("https://panel.apis.rotomlabsapis.com/onepanel/importer", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization:token
        },
        body: JSON.stringify({
          type: typeSelected,
          file_name: selectedFile.name,
          // base: 'one_dots',
          confirm: false,
        }),
      });
      // console.log('res', response)

      if (response.ok) {
        setLoadingPreCharge(false)
        const data = await response.json();
        console.log(data.errors,'data errores')
        if(data.status == 1){

          setValidationMessage("Validación exitosa.");
          setFileValidate(true)
          setFetchResponse(data);
        }else{
          setLoadingPreCharge(false)
          setValidationMessage("Error en la validación.");
          
        }
        // Maneja la respuesta de validación según sea necesario
      } else {
        setValidationMessage("Error en la respuesta del servicio.");
      }

      // Limpia el mensaje después de un tiempo
      setTimeout(() => {
        setValidationMessage("");
      }, 2000);
    } catch (error) {
      console.error("Error en la validación:", error);
      setValidationMessage("Hubo un problema en la validación.");
      setTimeout(() => {
        setValidationMessage("");
      }, 2000);
    }
  };

  const handleCharge = async () => {
    try {
      // Aquí realiza la llamada al servicio usando fetch
      setLoadingCharge(!loadingCharge)
      const response = await fetch("https://panel.apis.rotomlabsapis.com/onepanel/importer", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization:token//"eyJraWQiOiJBUjM5U3NcL3BcL2NvTjB0eWJ2TlNzSGtnR25PdkRwTEg3d2dFZEpDRTZic2M9IiwiYWxnIjoiUlMyNTYifQ.eyJzdWIiOiIxMTliMzUyMC1iMGMxLTcwMzMtYTEwMS1iODM1MjEzODBlNjMiLCJkZXZpY2Vfa2V5IjoidXMtZWFzdC0yXzZlM2U2MDk2LTYxNWEtNDEzYS1iYzhjLTIwMjc3NDkxYmYzYiIsImNvZ25pdG86Z3JvdXBzIjpbIm9uZV9kb3RzIl0sImlzcyI6Imh0dHBzOlwvXC9jb2duaXRvLWlkcC51cy1lYXN0LTIuYW1hem9uYXdzLmNvbVwvdXMtZWFzdC0yX3JDTmhEUXNHbSIsImNsaWVudF9pZCI6IjU3OW04aWRtZTg5dWxmczcyOXVnOHA1NXV0Iiwib3JpZ2luX2p0aSI6ImY5ZjgzYjkwLWVjNGYtNGUxNi1iYjlkLWNiNmRkZWQ0YzJkMSIsImV2ZW50X2lkIjoiYTAxNWIyMWEtZDMwOS00MWQzLWE5M2QtZTNjOGQ1OWRhODc0IiwidG9rZW5fdXNlIjoiYWNjZXNzIiwic2NvcGUiOiJhd3MuY29nbml0by5zaWduaW4udXNlci5hZG1pbiIsImF1dGhfdGltZSI6MTcyNzg4ODAxMSwiZXhwIjoxNzI3ODkxNjExLCJpYXQiOjE3Mjc4ODgwMTEsImp0aSI6ImI4ODVjOTI2LTdkYjItNDIxYi1iYzRkLWIwMjBkYzg5MTExNSIsInVzZXJuYW1lIjoiZG90c190ZXN0X2ltcG9ydGFkb3JAZG90cy5jb20ifQ.wSjqV3Pu_hCmjlokTahq3F1_0jozpNMuDzd6bmKZ6oLMW8CfE6-PjDllCo7AQLoX16d_D-pPLWcXJKW5IsaaN1Mxnr_unurxfaWfOnGRG0f88-MRITVs2ipDiX9RxhAZ20-emsWm1YBDAzYFGIoBdC08r8WuAktXBM5DZU3PnZXVi0PluCnJ6UvZve9LGjdhxYX_h1OoKXW-t-cK9TRrbzpOXc_kFsBUvkbzhuJgEgSml3dtLYRGYx8yhvMVHRek037DM15Ohxg13xEgDwGAlOhto0-HqdjNkyeuH2S14CoV2ViEMfk-Wwf_0qw7AcQCIgWrBpF54Ks2pqEIJ4JNtA"
        },
        body: JSON.stringify({
          type: typeSelected,
          file_name: selectedFile.name,
          // base: 'one_dots',
          confirm: true,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        if(data.status == 1){
          let message = data.single.message
          setChargeMessage(message);
          setLoadingCharge(false)
          // setFileValidate(true)
          // setFetchResponse(data);
        }else{
          setLoadingCharge(false)
          setChargeMessage("Error en la creacion.");
        }
        // Maneja la respuesta de validación según sea necesario
      } else {
        setLoadingCharge(false)
        setChargeMessage("Error en la respuesta del servicio.");
      }

      // Limpia el mensaje después de un tiempo
      setTimeout(() => {
        setChargeMessage("");
      }, 3000);
    } catch (error) {
      console.error("Error en la creacion:", error);
      setValidationMessage("Hubo un problema en la creacion.");
      setTimeout(() => {
        setChargeMessage("");
      }, 2000);
    }
  };

  const handleReset = async () => {
    try {

      setFileSelected(false);
      setFileUploaded(false);
      setErrorMessage("");
      setSuccessMessage("");
      setValidationMessage("");
      setFetchResponse(null);
      setFileValidate(false);
      setShowErrors(false)
      // Aquí realiza la llamada al servicio usando fetch

    } catch (error) {
      console.error("Error en la cancelacion:", error);
      setTimeout(() => {
        setValidationMessage("");
      }, 2000);
    }
  };

  const generateCSV = () => {
    if (fetchResponse && fetchResponse.details) {
      const { details } = fetchResponse;

      // Crear contenido CSV
      const csvContent = details.map((item, index) => {
        const rowNumbers = item.row_num.join(", ");
        const errors = item.errors.join("; ");
        return `${rowNumbers},${errors}`;
      }).join("\n");

      const header = "Row Numbers,Errors\n";
      const csvString = header + csvContent;
      // console.log(csvString)

      const blob = new Blob([csvString], { type: 'text/csv' });

        // Crear un enlace para la descarga del CSV
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'details.csv'; // Nombre del archivo CSV
        document.body.appendChild(a);
        a.click();

        // Limpiar el objeto URL y eliminar el enlace
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);

        return csvString

    }
  };

  const generateCSVString = () => {
    if (fetchResponse && fetchResponse.single.details) {

      const { details } = fetchResponse.single;

      // Crear contenido CSV
      const csvContent = details.map((item, index) => {
        const rowNumbers = item.row_num.join(", ");
        const errors = item.errors.join("; ");
        return `${rowNumbers},${errors}`;
      }).join("\n");

      const header = "Row Numbers,Errors\n";
      const csvString = header + csvContent;
      // console.log(csvString)



        return csvString

    }
  };

  return (
    <Formik
      initialValues={{ dropdown: "" }}
      onSubmit={(values) => handleUploadFile(values)}
    >
      {({ handleChange, handleSubmit, values }) => (
        <View style={{flex:1, flexDirection:'row'}}>
          <View style={{flex:1}}>

          </View>
          <View>
            <Button
              title="Indicadores"
              onPress={() => navigate('/indicadores')}
            />
          </View>
        <View style={styles.container}>

          <Picker
            selectedValue={values.dropdown}
            onValueChange={handleChange("dropdown")}
            style={styles.picker}
          >
            <Picker.Item label="Seleccione una opción..." value="" />
            <Picker.Item label="Perfect Store" value="perfect_stores" />
            <Picker.Item label="Users" value="users" />
            <Picker.Item label="Pos" value="pos" />
            <Picker.Item label="Ejecutions Audits" value="ejecutions_audits" />
          </Picker>
          <Button
            title="Seleccionar archivo (.xlsx)"
            onPress={handleSelectFile}
            disabled={ fileSelected}
          />

          <ErrorMessage visible={!!errorMessage} message={errorMessage} />

          <View style={styles.confirmButton}>
            <Button
              title="Subir archivo a S3"
              onPress={handleSubmit}
              disabled={!selectedFile || fileUploaded}
            />
          </View>
          <SuccessMessage visible={!!successMessage} message={successMessage} />

          {fileUploaded && (
            <View style={styles.validateButton}>
              <Button title={loadingValidate ? 'Cargando...' : "Validar"} onPress={handleValidation} />
            </View>
          )}

          <SuccessMessage visible={!!validationMessage} message={validationMessage} />
          {showErrors && (
            <View>
              <Text>Errores: </Text>
              {errors.map((item, index) => (
                <Text key={index}>{item}</Text>
              ))}
            </View>
          )}

          {fileValidate && (
            <View style={styles.validateButton}>
              <Button title={loadingPreCharge ? 'Cargando... ':"Pre cargar"} onPress={handlePreCharge} />
            </View>
          )}

          <ScrollView style={styles.scrollContainer}> 
            {fetchResponse && (
              <View style={styles.responseBox}>
                {typeSelected === 'perfect_stores' && (
                  <>
                    <Text>Total formularios: {fetchResponse.single.totalForms}</Text>
                    <Text>Para crear: {fetchResponse.single.toCreate}</Text>
                    <Text>Para updatear: {fetchResponse.single.toUpdate}</Text>
                    <Text>No creados: {fetchResponse.single.notCreate}</Text>
                    <Text>Formularios iguales al segmento: {fetchResponse.single.formsEqualSegment}</Text>
                    <Text>Formularios con mismo code: {fetchResponse.single.formsEqualCode}</Text>
                    <Text>Detalle: </Text>
                    <Text>{generateCSVString()}</Text>
                  </>
                )}

                {typeSelected === 'pos' && (
                  <>
                    <Text>Total pos: {fetchResponse.single.totalPos}</Text>
                    <Text>Pos a crear: {fetchResponse.single.toCreate}</Text>
                    <Text>Pos a updatear: {fetchResponse.single.toUpdate}</Text>
                    <Text>Pos con mismo code: {fetchResponse.single.equalCode}</Text>
                    <Text>Detalle de lo que va a crear: </Text>
                    
                    {fetchResponse.single.details.retailers.length > 0 && (<Text>Retailers: {fetchResponse.single.details.retailers}</Text>)}
                    {fetchResponse.single.details.areas.length > 0 && (<Text>Areas: {fetchResponse.single.details.areas}</Text>)}
                    {fetchResponse.single.details.clusters.length > 0 && (<Text>Clusters: {fetchResponse.single.details.clusters}</Text>)}
                    {fetchResponse.single.details.regions.length > 0 && (<Text>Regions: {fetchResponse.single.details.regions}</Text>)}
                    {fetchResponse.single.details.formats.length > 0 && (<Text>Formatos: {fetchResponse.single.details.formats}</Text>)}
                    {fetchResponse.single.details.flags.length > 0 && (<Text>Flags: {fetchResponse.single.details.flags}</Text>)}
                    {/* <Text>{generateCSVString()}</Text> */}
                  </>
                )}

                {typeSelected === 'users' && (
                  <>
                    <Text>Total users: {fetchResponse.single.total_usuarios}</Text>
                    <Text>Users a crear: {fetchResponse.single.usuarios_creados}</Text>
                    <Text>Users a updatear: {fetchResponse.single.usuarios_actualizadas}</Text>
                    <Text>Users a borrar cognito: {fetchResponse.single.usuarios_borrados_cognito}</Text>
                    <Text>Users no posibles de crear: {fetchResponse.single.usuarios_no_creados}</Text>
                    <Text>Users con mismo code: {fetchResponse.single.usuarios_mismo_code}</Text>
                    <Text>Detalle de lo que va a crear: </Text>
                    
                    {fetchResponse.single.creaciones.countries != undefined && (<Text>Countries: {fetchResponse.single.creaciones.countries}</Text>)}
                    {fetchResponse.single.creaciones.areas != undefined && (<Text>Areas: {fetchResponse.single.creaciones.areas}</Text>)}
                    {fetchResponse.single.creaciones.departments != undefined && (<Text>Departamentos: {fetchResponse.single.creaciones.departments}</Text>)}
                    {fetchResponse.single.creaciones.roles != undefined && (<Text>Roles: {fetchResponse.single.creaciones.roles}</Text>)}
                    {fetchResponse.single.creaciones.regions != undefined && (<Text>Regiones: {fetchResponse.single.creaciones.regions}</Text>)}
                    {fetchResponse.single.creaciones.flags != undefined && (<Text>Flags: {fetchResponse.single.creaciones.flags}</Text>)}
                    {fetchResponse.single.creaciones.profiles != undefined && (<Text>Perfiles: {fetchResponse.single.creaciones.profiles}</Text>)}
                    {/* <Text>{generateCSVString()}</Text> */}
                  </>
                )}

                {typeSelected === 'ejecutions_audits' && (
                  <>
                    <Text>Total formularios: {fetchResponse.single.totalForms}</Text>
                    <Text>Para crear: {fetchResponse.single.toCreate}</Text>
                    <Text>Para updatear: {fetchResponse.single.toUpdate}</Text>
                    <Text>No creados: {fetchResponse.single.notCreate}</Text>
                    <Text>Formularios iguales al segmento: {fetchResponse.single.formsEqualSegment}</Text>
                    <Text>Formularios con mismo code: {fetchResponse.single.formsEqualCode}</Text>
                    <Text>Detalle: </Text>
                    <Text style={styles.details_container}>{generateCSVString()}</Text>
                  </>
                )}

              </View>
            )}
          </ScrollView>

          {fetchResponse && fetchResponse.details && (
            <View style={styles.validateButton}>
              <Button title="Descargar CSV" onPress={generateCSV} />
            </View>
          )}

          {fetchResponse  && (
            <View style={styles.validateButton}>
              <Button title={loadingCharge ? 'Cargando...' :"Confirmar"} onPress={handleCharge} />
            </View>
          )}

          <SuccessMessage visible={!!chargeMessage} message={chargeMessage} />


          {/* {fetchResponse  && ( */}
            <View style={styles.validateButton}>
              <Button title="Cancelar" onPress={handleReset} />
            </View>
          {/* )} */}

        </View>
        <View style={{flex:1}}></View>
        </View>
      )}
    </Formik>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 2,
    justifyContent: "center",
    paddingVertical: 16,
    // width:500
  },
  formBox: {
    padding: 60,
    borderWidth: 1,
    borderColor: "#ddd",
    borderRadius: 10,
    backgroundColor: "#fff", // Fondo blanco para la caja
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.2,
    shadowRadius: 2,
    elevation: 2,
  },
  picker: {
    height: 50,
    marginBottom: 20,
  },
  confirmButton: {
    marginTop: 20,
  },
  responseBox: {
    marginTop: 20,
    padding: 10,
    backgroundColor: "#f9f9f9",
    borderRadius: 5,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 1,
    elevation: 1,
  },
  scrollContainer: {
    maxHeight: height * 0.10,  // Scroll para el contenido
  },
  validateButton: {
    marginTop: 10,
  }
});

export default Form;
